import React from 'react'
import Slider from 'react-slick'
import iconCheck from '../../../shared/assets/images/icon-check.svg'
import Button from '../../../shared/components/atoms/Button/Button'
import AlertMessagge from '../alertMessagge/alertMessagge'
import ChangePassword from '../changePassword/changePassword'
import PasswordVerifyContent from '../passwordVerifyContent/passwordVerifyContent'
import './passwordChangeModal.scss'
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase'

const PasswordChangeModal = props => {
	const sliderConf = {
		dots: false,
		infinite: false,
		easing: 'ease',
		useCSS: 1,
		slidesToShow: 1,
		slidesToScroll: 1,
		draggable: false,
		className: 'f-login-sections',
		swipeToSlide: false,
		swipe: false,
		adaptiveHeight: true,
	}

	const sliderRef = React.useRef()
	const [passRef, setPassRef] = React.useState()

	return (
		<div className='f-pass-modal'>
			{/* <div className="f-card-modal-head" >
                <span className="f-card-modal-head-icon" onClick={hideAction} >X</span>
            </div> */}
			<Slider ref={sliderRef} {...sliderConf}>
				<PasswordVerifyContent
					formValues={props.formValues}
					actualStorage={props.actualStorage}
					handleNextSlider={() => sliderRef.current.slickNext()}
					handleSetRef={value => setPassRef(value)}
				/>
				<ChangePassword
					type={props.type}
					handlePrevSlider={() => sliderRef.current.slickPrev()}
					handleNextSlider={() => sliderRef.current.slickNext()}
					passRef={passRef}
					actualStorage={props.actualStorage}
					sliderRef={sliderRef}
					setCurrentPayload={props.setCurrentPayload}
					setOTPModalVisibility={props.setOTPModalVisibility}
					setCurrentSlider={props.setCurrentSlider}
				/>
				<AlertMessagge
					icon={<img src={iconCheck} alt='check-correct' />}
					messagge='TU CONTRASEÑA HA SIDO CAMBIADA CON ÉXITO'
					description='Para continuar debes ingresar a tu cuenta nuevamente.'
					type='success'
					button={
						<Button
							type='button'
							onClickAction={props.closeModal}
							classname='f-button f-button--primary'
							text={convertText('IR A MI PERFIL')}
						/>
					}
				/>
			</Slider>
			<button className='f-exit-btn' onClick={props.closeModal}>
				X
			</button>
		</div>
	)
}

export default PasswordChangeModal
